import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import classNames from 'classnames';
import { LegacyTabs, LegacyTab } from '../../tabs/legacy-tabs/index.js';
import '../../utils/fetcher.js';
import { prependPrefix } from '../../utils/style.js';
import '../api/captcha.js';
import { getEnvConfig } from '../api/config.js';
import '@bilibili-maoer/web-utils';
import 'qs';
import { LegacyPasswordLogin } from '../legacy-password-login/index.js';
import { LegacyVerifyLogin } from '../legacy-verify-login/index.js';
import { ThirdPartyLogin } from '../third-party/index.js';
import { DOC_DUTY_URL, DOC_PRIVACY_URL } from '../utils/constants.js';
import '../../toast/index.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js/parse-int';
import '@babel/runtime-corejs3/core-js/object/keys';
import '@babel/runtime-corejs3/core-js/promise';
import 'lodash-es';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ELegacyLoginTab;

(function (ELegacyLoginTab) {
  ELegacyLoginTab["VerifyLogin"] = "verify-login";
  ELegacyLoginTab["PasswordLogin"] = "password-login";
})(ELegacyLoginTab || (ELegacyLoginTab = {}));

var Agreement = function Agreement(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prependPrefix('agreement'), className)
  }, /*#__PURE__*/React.createElement("span", null, "\u767B\u5F55\u5373\u4EE3\u8868\u60A8\u5DF2\u540C\u610F"), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: DOC_DUTY_URL
  }, "\u300A\u7528\u6237\u534F\u8BAE\u300B"), /*#__PURE__*/React.createElement("span", null, "\u548C"), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: DOC_PRIVACY_URL
  }, "\u300A\u9690\u79C1\u653F\u7B56\u300B"));
};
var LegacyLogin = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyLogin, _React$Component);

  var _super = _createSuper(LegacyLogin);

  function LegacyLogin(props) {
    var _this;

    _classCallCheck(this, LegacyLogin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleActiveKeyChange", function (activeKey) {
      _this.setState({
        activeKey: activeKey
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRememberChange", function () {
      _this.setState({
        rememberMe: !_this.state.rememberMe
      });
    });

    _this.state = {
      activeKey: ELegacyLoginTab.VerifyLogin,
      disabledCaptcha: false,
      rememberMe: true
    };
    return _this;
  }

  _createClass(LegacyLogin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      getEnvConfig().then(function (res) {
        var _res$info;

        _this2.setState({
          disabledCaptcha: !!((_res$info = res.info) !== null && _res$info !== void 0 && _res$info.DISABLE_NOCAPTCHA)
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var modal = this.props.modal;
      var _this$state = this.state,
          activeKey = _this$state.activeKey,
          disabledCaptcha = _this$state.disabledCaptcha,
          rememberMe = _this$state.rememberMe;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('legacy-login'), {
          modal: modal
        })
      }, /*#__PURE__*/React.createElement(LegacyTabs, {
        activeKey: activeKey,
        onSelect: this.handleActiveKeyChange
      }, /*#__PURE__*/React.createElement(LegacyTab, {
        actionKey: ELegacyLoginTab.VerifyLogin,
        title: "\u9A8C\u8BC1\u7801\u767B\u5F55"
      }, /*#__PURE__*/React.createElement(LegacyVerifyLogin, {
        modal: modal,
        rememberMe: rememberMe,
        onRememberChange: this.handleRememberChange,
        disabledCaptcha: disabledCaptcha
      })), /*#__PURE__*/React.createElement(LegacyTab, {
        actionKey: ELegacyLoginTab.PasswordLogin,
        title: "\u5BC6\u7801\u767B\u5F55"
      }, /*#__PURE__*/React.createElement(LegacyPasswordLogin, {
        modal: modal,
        rememberMe: rememberMe,
        onRememberChange: this.handleRememberChange,
        disabledCaptcha: disabledCaptcha
      }))), modal && /*#__PURE__*/React.createElement(Agreement, {
        className: prependPrefix('agreement-margin')
      }), /*#__PURE__*/React.createElement(ThirdPartyLogin, null));
    }
  }]);

  return LegacyLogin;
}(React.Component);

export { Agreement, LegacyLogin };
